import { Box, Typography } from "@mui/material"
import { useIsDesktop } from "common/MediaQueries"
import NextLink from "common/bit/NextLink"
import styled from "styled-components"

const StyledWrapper = styled(Box)<{ $margin?: boolean; $fontSize?: number }>`
  ${(p) => p.$margin && "margin-top: 70px"};
  flex: 1 1 25%;
  a {
    font-size: ${(p) => (p.$fontSize ? p.$fontSize : "18px")};
    font-weight: 300;
    margin-top: 20px;
    display: block;
    color: #3a3d46;
    ${(p) => p.theme.breakpoints.down("sm")} {
      text-decoration: underline;
    }
    &:hover {
      text-decoration: underline;
    }
  }
  ${(p) => p.theme.breakpoints.down("sm")} {
    margin-top: 40px;
  }
`

const StyledLinksWrapper = styled(Box)``

const StyledTitle = styled(Typography).attrs({ variant: "h2" })`
  font-size: 20px;
  font-weight: 300;
`

type SitemapLinks = {
  title: string
  links: Array<any>
  margin?: boolean
  fontSize?: number
}

const SitemapLinks = ({ title, links, margin, fontSize }: SitemapLinks) => {
  const isDesktop = useIsDesktop()

  return (
    <StyledWrapper $margin={isDesktop && margin} $fontSize={fontSize}>
      <StyledTitle>{title}</StyledTitle>
      {links.map((link, index) => (
        <StyledLinksWrapper key={index}>
          <NextLink href={link?.link ? link.link : "/"} openInNewTab>
            {link.text}
          </NextLink>
        </StyledLinksWrapper>
      ))}
    </StyledWrapper>
  )
}

export default SitemapLinks
